import {toast} from 'react-toastify'
import Apiservices from '../../lib/ApiServices'
import ApisMethods from './apisMethods'

const paymentMethod = {
  getChoose: (callback: any, setIsLoading: any) => {
    ApisMethods().get(`/vendor/payment-method/choose-payment-method`, callback, setIsLoading)
  },
  get: (callback: any, setIsLoading: any) => {
    ApisMethods().get(`/vendor/payment-method/get-payment-method`, callback, setIsLoading)
  },
  add: (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/payment-method/add-payment-method`, data, callback, setIsLoading)
  },
  put: (id: any, callback: any, setIsLoading: any) => {
    ApisMethods().put(
      `/vendor/payment-method/toggle-status-payment-method/${id}`,
      {},
      callback,
      setIsLoading
    )
  },
}
export default paymentMethod
